import Logger from '../../utils/logger/logger';
import BasePage from '../../components/base-page/base-page';

import './windows.scss';

class WindowsPage extends BasePage {
  onInit() {
    Logger.initialize();
  }
}
export default WindowsPage;

WindowsPage.initOnDomLoaded();

